import React from "react";
import { BasicFieldProps } from "./props";
import classNames from "classnames";

export const Textarea = ({ field, fieldId }: BasicFieldProps): JSX.Element => {
  const { label, placeholder, isRequired, cssClass, id, layoutGridColumnSpan } = field;
  // Gravity Form field ID ~ name.
  const gfName = `input_${id}`;
  return (
    <div
      className={classNames({
        [cssClass]: cssClass,
        required: isRequired,
      })}
      style={{ "--col-width": layoutGridColumnSpan || 12 } as React.CSSProperties}
    >
      <label htmlFor={fieldId}>{label}</label>
      <div className="animation-container">
        <textarea name={gfName} id={fieldId} placeholder={placeholder} required={!!isRequired} />
        <div className="border top-right"></div>
        <div className="border bottom-left"></div>
      </div>
    </div>
  );
};
